import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { UserData } from "src/interfaces/ManageUsersAndRole.interface";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";
import useAppToast from "src/hooks/useAppToast";
import { deleteManagerAsync, deleteUserStaff } from "src/redux/actions/manageUserActions";
import { useAppSelector } from "src/redux/storeHooks";

interface DeleteUserModalProps {
  show: boolean;
  handleClose: () => void;
  user: UserData | undefined
  fetchUserData: () => void
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  show,
  handleClose,
  user,
  fetchUserData
}) => {
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData);
  const isSuperAdmin = fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.account_type === "ADMIN_STAFF";
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const { successToast, warningToast, errorToast } = useAppToast();
    const handleConfirm = async () => {
      if (!user?.id) return;
      setLoading(true);
      const actionApi = isSuperAdmin ? deleteManagerAsync : deleteUserStaff;
        await dispatch(actionApi({ id: user.id }))
        .then((response)=> {
          if(response.payload.status_code == 200){
            successToast(response.payload.massage)
          }
          if(response?.payload?.data?.status_code === 400) {
            warningToast(response?.payload?.data?.massage);
          }
          fetchUserData();
          handleClose()
        }).catch((e)=>{
          warningToast(e.payload.massage)
        }).finally(()=>{
          setLoading(false)
        })
    };
  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header className="bg-danger text-white border-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          Confirm Deletion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="fs-5 mb-2">Are you sure you want to delete this user?</p>
        <p className="text-muted">This action is irreversible and will remove the user permanently.</p>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserModal;
